import { ValueOfKey } from '../../utils-types';

export const pathQueryParams = {
  challengeId: 'challengeId',
  phoneNumber: 'phoneNumber',
} as const;

export type PathQueryParams = ValueOfKey<typeof pathQueryParams>;
